export default __webpack_public_path__ + "static/media/dropImage1.3bb03d43.PNG";